import { apiEndpoint } from '@/config';
import { fetcher } from '@/lib/swr';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
  CustomerViewModel,
} from '@hidayahlab/academy-suite-corelib';
import { useParams } from 'next/navigation';
import useSWR from 'swr';

export function useGetCustomer() {
  const params = useParams();
  let domain = params?.domain as string;

  if (domain?.includes('localhost:')) {
    domain = 'localhost';
  }

  const apiUrl = domain
    ? `${apiEndpoint}/customers/by-domain/${domain}/with-settings`
    : null;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<CustomerViewModel>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url));

  return {
    customer: data?.data,
    isLoading,
    isError: error,
  };
}
